import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import { FcAlarmClock } from "react-icons/fc";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import swal from "sweetalert";
import { BASE_URL } from '../../insightConfig/insightConfig';
import ResultPreview from '../ResultPreview/ResultPreview';
import Questionsummary from '../QuizComponent/Questionsummary/Questionsummary';
import "../QuizComponent/QuestionLayout/QuestionLayout.css";
// import { toast } from 'react-toastify';
import { createBrowserHistory } from 'history';
import parse from 'html-react-parser';
import ExamHeader from '../CUET/OnlineTest/ExamHeader';
import ExamHistorySection from '../CUET/OnlineTest/ExamHistorySection';

function AttemptTestUGC() {
    const timerRef = useRef(null);
    const alert = useAlert();
    const navigate = useNavigate();
    const location = useLocation();
    // const { state: { testData } } = useLocation();
    const testDetails = location?.state?.testDetails;
    const { SubjectID, testNumber, exam_type, orderId, questionLimit, negativeMarking, marksPerQuestion, Duration, questionsToBeAttempted, reAttempt, Subject } = testDetails || {};
    console.log(testDetails);

    const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));
    //raaz work 
    const [testQuestions, setTestQuestions] = useState([]);
    const [selectedQuestionNumber, setSelectedQuestionNumber] = useState(1);
    const [selectedQuestion, setSelectedQuestion] = useState()
    const [answerOfCurrentQuestion, setAnswerOfCurrentQuestion] = useState('')
    const [attemptedQuestions, setAttemptedQuestions] = useState([])
    const [attemptedAndMarkedForReview, setAttemptedAndMarkedForReview] = useState([]);
    const [markForReviewQuestionsArray, setMarkForReviewQuestionsArray] = useState([])
    const [toggleMarkForReview, setToggleMarkForReview] = useState(false)
    const [viewedQuestionsArray, setViewedQuestionsArray] = useState([])
    const [finishTest, setFinishTest] = useState(false)
    const [questionsLoaded, setQuestionsLoaded] = useState(false);
    useEffect(() => {
        if (location?.state?.testData) {
            localStorage.setItem('testData', JSON.stringify(location.state.testData));
        }
    }, [location.state]);
    useEffect(() => {
        const { pathname, state } = location;

        const handlePopState = () => {
            if (pathname.includes('testseriesstart')) {
                // Block back by pushing current path & state again
                window.history.pushState(state ?? null, '', pathname);
            }
        };

        if (pathname.includes('testseriesstart')) {
            // Initial push to prevent back navigation
            window.history.pushState(state ?? null, '', pathname);
            window.addEventListener('popstate', handlePopState);
        }

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [location.pathname, location.state]);


    let { packageid } = useParams()
    const storedAuthToken = localStorage.getItem('authtoken');

    //time functionality
    let intialTime = Number(Duration) * 60
    const [timeRemaining, setTimeRemaining] = useState(intialTime);
    const [timeUp, setTimeUp] = useState(false)
    const hours = Math.floor(timeRemaining / 3600);
    const minutes = Math.floor((timeRemaining % 3600) / 60);
    const seconds = timeRemaining % 60;
    // const minutes = Math.floor(timeRemaining / 60);
    // const seconds = (timeRemaining % 60);


    useEffect(() => {
        if (testQuestions?.length) {
            setQuestionsLoaded(true);
        }
    }, [testQuestions])

    useEffect(() => {
        if (testQuestions && testQuestions?.length > 0) {
            // let initialTestResponseObjs = new Array(testQuestions?.length).fill(null).map((_, index) => ({
            //   questionNumber: index + 1,
            //   selectedOption: '',
            //   correctOption: testQuestions.find(question => question.QNo == index + 1)?.Answer,
            //   markForReview: false,
            //   isQuestionViewed: false,
            //   attemptedAndMarkedForReview: false
            // }));
            const initialTestResponseObjs = testQuestions.map((data, index) => ({
                Question: data.Question,
                OptionA: data.OptionA,
                OptionB: data.OptionB,
                OptionC: data.OptionC,
                OptionD: data.OptionD,
                SectionID: data.SectionID,
                TopicID: data.TopicID,
                questionNumber: index + 1,
                selectedOption: '',
                correctOption: data?.Answer,
                QuestionID: data.QuizID,
                markForReview: false,
                isQuestionViewed: false,
                attemptedAndMarkedForReview: false
            }));

            const UGC_testSeriesReportArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));

            if (UGC_testSeriesReportArray && UGC_testSeriesReportArray?.length > 0) {
                const testToBeContinued = UGC_testSeriesReportArray.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);

                if (testToBeContinued) {
                    setTimeRemaining(testToBeContinued?.remainingTime);
                    setSelectedQuestionNumber(testToBeContinued.lastQuestion);
                    setAttemptedQuestions(testToBeContinued.userResponseObj?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));
                    setAttemptedAndMarkedForReview(testToBeContinued.userResponseObj?.filter((question) => question.selectedOption && question.attemptedAndMarkedForReview)?.map((question) => question.questionNumber))
                } else {
                    UGC_testSeriesReportArray.push({
                        isTestFinished: false,
                        SubjectID: SubjectID,
                        testNumber: testNumber,
                        orderId: orderId,
                        exam_type: exam_type,
                        reAttempt: reAttempt || false,
                        startTime: new Date(),
                        lastQuestion: 1,
                        remainingTime: intialTime,
                        userResponseObj: initialTestResponseObjs
                    });

                    localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(UGC_testSeriesReportArray));
                    setSelectedQuestionNumber(1);
                }
            } else {
                const newTestDetails = [{
                    isTestFinished: false,
                    SubjectID: SubjectID,
                    testNumber: testNumber,
                    orderId: orderId,
                    exam_type: exam_type,
                    reAttempt: reAttempt || false,
                    startTime: new Date(),
                    lastQuestion: 1,
                    remainingTime: Duration * 60,
                    userResponseObj: initialTestResponseObjs,
                }];

                localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(newTestDetails));
                setSelectedQuestionNumber(1);
                setAttemptedQuestions([]);
                setAttemptedAndMarkedForReview([]);
            }
        }
    }, [testQuestions])


    useEffect(() => {
        if (finishTest || timeUp) return;

        if (questionsLoaded) {
            timerRef.current = setInterval(() => {
                setTimeRemaining(prevTime => {
                    if (prevTime > 0) {
                        const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray")) || [];
                        const testIndex = allTestsReportsArray?.findIndex(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);
                        if (testIndex !== -1) {
                            const copyOfTestDetails = [...allTestsReportsArray];
                            copyOfTestDetails[testIndex].remainingTime = prevTime - 1;
                            localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(copyOfTestDetails));
                        }
                        return prevTime - 1;
                    } else {
                        if (!timeUp) {
                            setTimeUp(true);
                            swal("Time's up! Please submit your test.");
                        }
                        clearInterval(timerRef.current);
                        return 0;
                    }
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [Duration, questionsLoaded]);


    useEffect(() => {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));
        const currentTest = allTestsReportsArray?.find((test) => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);

        // console.log(currentTest.userResponseObj);
        if (currentTest?.userResponseObj?.length > 0) {
            const questions = currentTest?.userResponseObj.map((data, index) => {
                return {
                    QNo: data.questionNumber,
                    QuizID: data.QuestionID,
                    Question: data.Question,
                    OptionA: data.OptionA,
                    OptionB: data.OptionB,
                    OptionC: data.OptionC,
                    OptionD: data.OptionD,
                    Answer: data?.correctOption,
                    SectionID: data.SectionID,
                    TopicID: data.TopicID
                }
            })
            console.log(questions);
            setTestQuestions(questions);
        } else {
            if (testQuestions?.length === 0) {
                axios.get(`${BASE_URL}/ugc/user/test-questions/${exam_type}/${questionLimit}/${SubjectID ?? ''}`).then((response) => {
                    setTestQuestions(response.data.questions);
                }).catch((error) => {
                    const errorMsg = error.response?.data?.message || "Something went wrong while fetching questions";
                    alert.show(errorMsg);
                    console.error('Error fetching questions:', error);
                    navigate('/StudentDashboard', { state: { prePath: location.pathname, testDetails: location?.state?.testDetails } });
                });
            }
        }

        if (currentTest?.isTestFinished == true) {
            setFinishTest(true)
            swal(
                "Test Finished! Please submit your test."
            )
        } else if (currentTest && currentTest?.remainingTime < 1) {
            setTimeUp(true)
            swal(
                "Time's up! Please submit your test."
            )
        }
    }, [])



    useEffect(() => {
        if (selectedQuestionNumber) {
            const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));

            if (allTestsReportsArray) {
                const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);

                if (selectedQuestionNumber != testQuestions?.length + 1) {
                    currentTest.lastQuestion = selectedQuestionNumber;
                }

                const userResponseObjForCurrentTest = currentTest?.userResponseObj
                let questionObj = userResponseObjForCurrentTest?.find((question) => question.questionNumber == selectedQuestionNumber)

                setAnswerOfCurrentQuestion(questionObj?.selectedOption)



                if (questionObj) {
                    // questionObj.markForReview = false;
                    questionObj.isQuestionViewed = true;
                }
                localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));

                setAttemptedQuestions(userResponseObjForCurrentTest?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));
                setAttemptedAndMarkedForReview(userResponseObjForCurrentTest?.filter((question) => question.selectedOption && question.attemptedAndMarkedForReview)?.map((question) => question.questionNumber));

                setMarkForReviewQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.markForReview == true && question.selectedOption == '')?.map((question) => question.questionNumber))
                setViewedQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.isQuestionViewed == true)?.map((question) => question.questionNumber))


            }
        }
        let selectedQuestion = testQuestions.find(question => question.QNo == selectedQuestionNumber);
        setSelectedQuestion(selectedQuestion);
    }, [selectedQuestionNumber, testQuestions, answerOfCurrentQuestion, toggleMarkForReview])












    const renderhtml = (paragraphs) => {
        return <p className='renderhtml' dangerouslySetInnerHTML={{ __html: paragraphs }} />;
    };

    const renderhtml1 = (paragraphs) => {
        return <b className='renderhtml1' dangerouslySetInnerHTML={{ __html: paragraphs }} />;
    };

    const selectAnswerHandler = (value) => {
        setAnswerOfCurrentQuestion(value)
        const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));

        const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);

        const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
        selectedQuestionObj.selectedOption = value;
        selectedQuestionObj.attemptedAndMarkedForReview = selectedQuestionObj.markForReview && selectedQuestionObj.selectedOption ? true : false;
        localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
        setToggleMarkForReview(!toggleMarkForReview)
    }
    const handleClear = () => {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));
        const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);

        const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
        selectedQuestionObj.selectedOption = '';
        selectedQuestionObj.attemptedAndMarkedForReview = selectedQuestionObj.markForReview && selectedQuestionObj.selectedOption ? true : false;
        localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
        setAnswerOfCurrentQuestion('')
        setToggleMarkForReview(!toggleMarkForReview)
    }
    const handleMarkForReview = () => {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));
        const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);
        const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
        selectedQuestionObj.markForReview = !selectedQuestionObj.markForReview;
        selectedQuestionObj.attemptedAndMarkedForReview = selectedQuestionObj.markForReview && selectedQuestionObj.selectedOption ? true : false;
        localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
        setToggleMarkForReview(!toggleMarkForReview)
    }



    const handleFinishTest = () => {
        swal({
            title: "Are you sure?",
            text: "Once finished, you will not be able to return to the test",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((yes) => {
            if (yes) {
                const allTestsReportsArray = JSON.parse(localStorage.getItem("UGC_TestSeriesReportArray"));
                const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);
                currentTest.isTestFinished = true;
                localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
                setFinishTest(true)
                swal(
                    "Test Finished! Please submit your test."
                )
            }
        })
    }
    const deleteReportFromLS = () => {
        const indexOfCurrentTest = allTestsReportsArray?.findIndex(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);
        allTestsReportsArray.splice(indexOfCurrentTest, 1);
        localStorage.setItem("UGC_TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
    }

    const increaseAttemptCount = async (answerSheet) => {
        try {
            const response = await axios.post(BASE_URL + `/ugc/user/increaseUGCAttemptCount/${orderId}/${testNumber}/${SubjectID ?? ''}`, { answerSheet });
        } catch (error) {
            console.log(error);
        }
    }


    const finalSubmitTest = async () => {
        try {
            const currentTest = allTestsReportsArray?.find(test => /* test.SubjectID === SubjectID && */ test.testNumber == testNumber && test.orderId == orderId);
            let correctQuestions = 0;
            let wrongQuestions = 0;
            let correctMarks = 0;
            let wrongMarks = 0;
            let totalQuestions = testQuestions?.length;
            let startTime = currentTest.startTime;
            let attemptedQuestions = 0;
            let notVisitedQuestions = 0;

            let userResponseObj = currentTest.userResponseObj;
            notVisitedQuestions = userResponseObj.filter((question) => question.isQuestionViewed !== true)?.length

            userResponseObj.map(obj => {
                if (obj.selectedOption != '') {
                    attemptedQuestions++;
                    if (obj.correctOption == obj.selectedOption) {
                        correctMarks = correctMarks + Number(marksPerQuestion);
                        correctQuestions++;
                    } else {
                        wrongMarks = wrongMarks + Number(negativeMarking);
                        wrongQuestions++;
                    }

                }
            })
            let testReport = { totalQuestions, questionsToBeAttempted, attemptedQuestions, correctQuestions, wrongQuestions, notVisitedQuestions, correctMarks, wrongMarks, negativeMarking: negativeMarking, marksPerQuestion: marksPerQuestion, startTime, answerSheet: userResponseObj, orderId: currentTest.orderId, SubjectID: currentTest.SubjectID, testNumber: currentTest.testNumber, exam_type: currentTest.exam_type }
            if (currentTest?.reAttempt === false) {
                const response = await axios.post(BASE_URL + `/ugc/user/insertUGC_TestReport`, testReport);
                if (response.data.statusCode == 200) {
                    deleteReportFromLS();
                    swal(response.data.message, {
                        icon: "success",
                        buttons: {
                            confirm: {
                                text: "OK",
                                value: true,
                                visible: true,
                                closeModal: true
                            }
                        }
                    }).then(() => {
                        console.log('report submitted');
                        navigate('/ugc-net/online-exam/report', { state: { testDetails } })
                    })
                }
            } else {
                console.log(testReport.answerSheet);
                deleteReportFromLS();
                increaseAttemptCount(testReport.answerSheet);
                let reAttemptReport = {
                    ...testReport,
                    answersheet: testReport.answerSheet,
                    totalquestion: totalQuestions,
                    attempted_questions: attemptedQuestions,
                    correct_questions: correctQuestions,
                    wrongquestions: wrongQuestions,
                    testcorrectmarks: correctMarks,
                    testwrongmarks: wrongMarks,
                    NetScore: correctMarks - wrongMarks,
                }
                navigate('/ugc-net/online-exam/report', { state: { reAttemptReport, testDetails } });
            }
        } catch (error) {
            swal("Oops", "Something went wrong! Please Try Again", { icon: "error" })
            console.log(error)
        }
    }

    const [unsavedChanges, setUnsavedChanges] = useState(true);
    const history = createBrowserHistory();
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (unsavedChanges) {
                const message = "Leave site? Changes you made may not be saved.";
                event.returnValue = message;  // Standard for most browsers
                return message;  // For some older browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Block navigation using history
        const unblock = history.block((location, action) => {
            if (unsavedChanges) {
                const message = "Leave site? Changes you made may not be saved.";
                if (window.confirm(message)) {
                    unblock();  // Allow the navigation
                } else {
                    return false;  // Block the navigation
                }
            }
            return undefined;  // Allow the navigation
        });


        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            unblock();
        };
    }, [unsavedChanges]);


    return (
        <>
            <div
                className="container-fluid p-3"
                style={{ position: "absolute", top: "0", background: "white", zIndex: "1000" }}
            >
                {testQuestions?.length ? (
                    <>
                        {/* ✅ Exam Header */}
                        <ExamHeader
                            module="UGC-NET"
                            exam_type={exam_type}
                            Subject={Subject}
                            SubjectID={SubjectID}
                            testOver={finishTest || timeUp}
                            hours={hours}
                            minutes={minutes}
                            seconds={seconds}
                        />

                        {/* ✅ Main Content Area */}
                        {!finishTest && !timeUp ? (
                            <div className="row mt-3">
                                {/* Left Section (Questions) */}
                                <div className="col-lg-8 mb-3" style={{ height: "100vh", overflowY: "scroll" }}>
                                    <>
                                        {/* Question Preview */}
                                        <div className="card py-3 px-3 mb-3">
                                            {selectedQuestion?.QNo ? (
                                                <div className="mb-2">
                                                    <span className="text-success fw-bold">
                                                        ({selectedQuestion.QNo}).
                                                    </span>{" "}
                                                    {parse(selectedQuestion.Question)}
                                                </div>
                                            ) : null}

                                            <ul className="answer-list list-unstyled mt-3">
                                                <li
                                                    style={{
                                                        pointerEvents:
                                                            attemptedQuestions?.length >= questionsToBeAttempted ? "none" : "auto",
                                                    }}
                                                    className={answerOfCurrentQuestion?.includes("A") ? "selected" : ""}
                                                    onClick={() => selectAnswerHandler("A")}
                                                >
                                                    <input
                                                        type="radio"
                                                        className="me-2 mb-1"
                                                        style={{ width: "20px", height: "20px" }}
                                                        name="option1"
                                                        id="option_1"
                                                        onClick={() => selectAnswerHandler("A")}
                                                        checked={answerOfCurrentQuestion?.includes("A")}
                                                    />
                                                    <label htmlFor="option_1">
                                                        <b>(A) {renderhtml1(selectedQuestion?.OptionA)}</b>
                                                    </label>
                                                </li>

                                                <li
                                                    style={{
                                                        pointerEvents:
                                                            attemptedQuestions?.length >= questionsToBeAttempted ? "none" : "auto",
                                                    }}
                                                    className={answerOfCurrentQuestion?.includes("B") ? "selected" : ""}
                                                    onClick={() => selectAnswerHandler("B")}
                                                >
                                                    <input
                                                        type="radio"
                                                        className="me-2 mb-1"
                                                        style={{ width: "20px", height: "20px" }}
                                                        name="option2"
                                                        id="option_2"
                                                        onClick={() => selectAnswerHandler("B")}
                                                        checked={answerOfCurrentQuestion?.includes("B")}
                                                    />
                                                    <label htmlFor="option_2">
                                                        <b>(B) {renderhtml1(selectedQuestion?.OptionB)}</b>
                                                    </label>
                                                </li>

                                                <li
                                                    style={{
                                                        pointerEvents:
                                                            attemptedQuestions?.length >= questionsToBeAttempted ? "none" : "auto",
                                                    }}
                                                    className={answerOfCurrentQuestion?.includes("C") ? "selected" : ""}
                                                    onClick={() => selectAnswerHandler("C")}
                                                >
                                                    <input
                                                        type="radio"
                                                        className="me-2 mb-1"
                                                        style={{ width: "20px", height: "20px" }}
                                                        name="option3"
                                                        id="option_3"
                                                        onClick={() => selectAnswerHandler("C")}
                                                        checked={answerOfCurrentQuestion?.includes("C")}
                                                    />
                                                    <label htmlFor="option_3">
                                                        <b>(C) {renderhtml1(selectedQuestion?.OptionC)}</b>
                                                    </label>
                                                </li>

                                                <li
                                                    style={{
                                                        pointerEvents:
                                                            attemptedQuestions?.length >= questionsToBeAttempted ? "none" : "auto",
                                                    }}
                                                    className={answerOfCurrentQuestion?.includes("D") ? "selected" : ""}
                                                    onClick={() => selectAnswerHandler("D")}
                                                >
                                                    <input
                                                        type="radio"
                                                        className="me-2 mb-1"
                                                        style={{ width: "20px", height: "20px" }}
                                                        name="option4"
                                                        id="option_4"
                                                        onClick={() => selectAnswerHandler("D")}
                                                        checked={answerOfCurrentQuestion?.includes("D")}
                                                    />
                                                    <label htmlFor="option_4">
                                                        <b>(D) {renderhtml1(selectedQuestion?.OptionD)}</b>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
                                            {/* Left Side Buttons */}
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedQuestionNumber > 1 && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', padding: '10px 22px', fontWeight: 'bold' }}
                                                        onClick={() => {
                                                            setSelectedQuestionNumber(selectedQuestionNumber - 1);
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                        ⬅ Previous
                                                    </button>
                                                )}

                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: '#343a40', color: 'white', border: 'none', borderRadius: '4px', padding: '10px 22px', fontWeight: 'bold' }}
                                                    onClick={handleClear}
                                                >
                                                    🧹 Clear
                                                </button>

                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: '#ffc107', color: 'black', border: 'none', borderRadius: '4px', padding: '10px 22px', fontWeight: 'bold' }}
                                                    onClick={handleMarkForReview}
                                                >
                                                    🔖 Mark for Review
                                                </button>
                                            </div>

                                            {/* Right Side Buttons */}
                                            <div>
                                                {selectedQuestionNumber >= testQuestions?.length ||
                                                    attemptedQuestions?.length >= questionsToBeAttempted ? (
                                                    <button
                                                        type="button"
                                                        onClick={handleFinishTest}
                                                        style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', padding: '10px 22px', fontWeight: 'bold' }}
                                                    >
                                                        Finish
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', padding: '10px 22px', fontWeight: 'bold' }}
                                                        onClick={() => {
                                                            setSelectedQuestionNumber(selectedQuestionNumber + 1);
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                        Save & Next ➡
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                    </>
                                    {/* ) : ( */}

                                    {/* )} */}
                                </div>

                                {/* Right Section (History) */}
                                <div className="col-lg-4">
                                    <div className="card" style={{ height: "550px", overflowY: "scroll" }}>
                                        <ExamHistorySection
                                            attemptedQuestions={attemptedQuestions}
                                            markForReviewQuestionsArray={markForReviewQuestionsArray}
                                            attemptedAndMarkedForReview={attemptedAndMarkedForReview}
                                            testQuestions={testQuestions}
                                            viewedQuestionsArray={viewedQuestionsArray}
                                            setSelectedQuestionNumber={setSelectedQuestionNumber}
                                            selectedQuestionNumber={selectedQuestionNumber}
                                            handleFinishTest={handleFinishTest}
                                            finishTest={finishTest}
                                            totalQuestions={questionLimit || 50}
                                            isCUET={true}
                                        />
                                    </div>
                                </div>
                            </div>) :
                            <>
                                <ResultPreview
                                    testQuestions={testQuestions}
                                    viewedQuestionsArray={viewedQuestionsArray}
                                    attemptedQuestions={attemptedQuestions}
                                    markForReviewQuestionsArray={markForReviewQuestionsArray}
                                    questionsToBeAttempted={questionsToBeAttempted}
                                    attemptedAndMarkedForReview={attemptedAndMarkedForReview}
                                    isDynamicTest={true}

                                />
                                <div className="p-3 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        style={{ backgroundColor: '#6e1158', color: 'white', border: 'none', borderRadius: '4px', padding: '12px 30px', fontWeight: 'bold', borderBottom: '4px solid red' }}
                                        onClick={finalSubmitTest}
                                    >
                                        Final Submit
                                    </button>
                                </div>
                            </>}
                    </>
                ) : (
                    /* ✅ Loader when test not ready */
                    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <h4 className="fw-bold text-secondary">Getting your test ready...</h4>
                        <p className="text-muted">Please wait while we load the questions.</p>
                    </div>
                )}
            </div>
        </>
    )
}

export default AttemptTestUGC